export const headerMenuItems = (t) => [
	{
		value: "manager",
		image: require("@/assets/images/manager_white.png"),
		label: t("manager"),
		roles: ["admin", "superuser"],
	},
	{
		value: "coach",
		image: require("@/assets/images/coach_white.png"),
		label: t("coach"),
		roles: ["coach"],
	},
	{
		value: "analyst",
		image: require("@/assets/images/coach_white.png"),
		label: t("match_analyst"),
		roles: ["analyst"],
	},
	{
		value: "player",
		image: require("@/assets/images/player_white.png"),
		label: t("player"),
		roles: ["player"],
	},
	{
		value: "scout",
		image: require("@/assets/images/scout_white.png"),
		label: t("scout"),
		roles: ["scout"],
	},
	{
		value: "settings",
		image: require("@/assets/images/settings_white.png"),
		label: t("settings"),
		roles: ["admin", "superuser"],
	},
];

export const genderOptions = [
	{label: "F", value: "F"},
	{label: "M", value: "M"},
];
export const sideOptions = (t) => [
	{value: "Destro", label: t("right")},
	{value: "Sinistro", label: t("left")},
	{value: "Entrambi", label: t("both")},
];
export const playerRoleOptions = (t) => [
	{label: t("goalkeeper"), value: "goalkeeper"},
	{label: t("movement_player"), value: "movement_player"},
];
export const categoryYearOptions = [
	{label: "2023/24", value: "2023/24"},
	{label: "2022/23", value: "2022/23"},
];

export const prospectPlayerStatus = (t) => [
	{label: t("to_try"), value: "reported"},
	{label: t("sampled"), value: "valuated"},
	{label: t("discarded"), value: "discarted"},
	{label: t("buyed"), value: "buyed"},
];

export const rpeOptions = [
	{value: "1", label: "1 - Molto leggero" /*, color: "#e0f7ff"*/},
	{value: "2", label: "2 - Leggero" /*, color: "#bed3ff"*/},
	{value: "3", label: "3 - Leggero" /*, color: "#bed3ff"*/},
	{value: "4", label: "4 - Moderato" /*, color: "#cbffb6"*/},
	{value: "5", label: "5 - Moderato" /*, color: "#cbffb6"*/},
	{value: "6", label: "6 - Moderato" /*, color: "#cbffb6"*/},
	{value: "7", label: "7 - Pesante" /*, color: "#fbd67d"*/},
	{value: "8", label: "8 - Pesante" /*, color: "#fbd67d"*/},
	{value: "9", label: "9 - Molto pesante" /*, color: "#f88266"*/},
	{value: "10", label: "10 - Estremamente pesante" /*, color: "#ff5559"*/},
];

export const tqrOptions = [
	{value: "6", label: "6 - Nessun recupero" /*, color: "#f88266"*/},
	{value: "7", label: "7 - Nessun recupero" /*, color: "#f88266"*/},
	{
		value: "8",
		label: "8 - Recupero estremamente scarso" /*, color: "#f9acac"*/,
	},
	{
		value: "9",
		label: "9 - Recupero molto scarso" /*, color: "#f7e5a7"*/,
	},
	{
		value: "10",
		label: "10 - Recupero molto scarso" /*, color: "#f7e5a7"*/,
	},
	{value: "11", label: "11 - Recupero scarso" /*, color: "#f7e84f"*/},
	{value: "12", label: "12 - Recupero scarso" /*, color: "#f7e84f"*/},
	{
		value: "13",
		label: "13 - Recupero ragionevole" /*, color: "#a7ffa8"*/,
	},
	{
		value: "14",
		label: "14 - Recupero ragionevole" /*, color: "#a7ffa8"*/,
	},
	{value: "15", label: "15 - Recupero buono" /*, color: "#76cd71"*/},
	{value: "16", label: "16 - Recupero buono" /*, color: "#76cd71"*/},
	{
		value: "17",
		label: "17 - Recupero molto buono" /*, color: "#cefaf8"*/,
	},
	{
		value: "18",
		label: "18 - Recupero molto buono" /*, color: "#cefaf8"*/,
	},
	{value: "19", label: "19 - Recupero massimo" /*, color: "#98c6ff"*/},
	{value: "20", label: "20 - Recupero massimo" /*, color: "#98c6ff"*/},
];

export const vasOptions = [
	{value: "0", label: "0 - Nessun dolore"},
	{value: "1", label: "1 - Dolore molto lieve"},
	{value: "2", label: "2 - Dolore molto lieve"},
	{value: "3", label: "3 - Dolore molto lieve"},
	{value: "4", label: "4 - Dolore lieve"},
	{value: "5", label: "5 - Dolore lieve"},
	{value: "6", label: "6 - Dolore moderato"},
	{value: "7", label: "7 - Dolore moderato"},
	{value: "8", label: "8 - Dolore forte"},
	{value: "9", label: "9 - Dolore forte"},
	{value: "10", label: "10 - Dolore molto forte"},
];

export const medicalRecordTypes = [
	{label: "Infortunio", value: "injury"},
	{label: "Malattia", value: "illness"},
];

export const statusOptions = [
	{value: "Interno", label: "Rosa"},
	{value: "Prestito", label: "Prestito uscita"},
	{value: "Prestito_in", label: "Prestito entrata"},
	{value: "Esterno", label: "Ceduto"},
];

export const playerRoles = [
	{value: "Portiere", label: "Portiere", groupLabel: "Portieri", order: 1},
	{value: "Difensore", label: "Difensore", groupLabel: "Difensori", order: 2},
	{
		value: "Centrocampista",
		label: "Centrocampista",
		groupLabel: "Centrocampisti",
		order: 3,
	},
	{
		value: "Esterno",
		label: "Esterno",
		groupLabel: "Esterni",
		order: 4,
	},
	{
		value: "Attaccante",
		label: "Attaccante",
		groupLabel: "Attaccanti",
		order: 5,
	},
];

export const modulesOptions = [
	{value: "4-4-2", label: "4-4-2"},
	{value: "4-3-3", label: "4-3-3"},
	{value: "3-4-3", label: "3-4-3"},
	{value: "3-5-2", label: "3-5-2"},
];

export const matchTypesOptions = [
	{value: "Amichevole", label: "Amichevole", ordinal: 1},
	{value: "Campionato", label: "Campionato", ordinal: 2},
	{value: "Coppa", label: "Coppa", ordinal: 3},
	{value: "Torneo", label: "Torneo", ordinal: 4},
];

export const fieldsOptions = [
	{value: "3 Campanili", label: "3 Campanili"},
	{value: "G.  Mugnaini", label: "G.  Mugnaini"},
	{value: "I. Ferrando", label: "I. Ferrando"},
	{value: "R. Garrone", label: "R. Garrone"},
	{value: "Sciorba Stadium", label: "Sciorba Stadium"},
	{value: "Villa Gavotti", label: "Villa Gavotti"},
	{value: "Marcelline", label: "Marcelline"},
	{value: "C.S. Golfo Paradiso", label: "C.S. Golfo Paradiso"},
];

export const attendanceStatusOptions = [
	{label: "Presente", value: "Presente"},
	{label: "Assente", value: "Assente"},
	{label: "Infortunato", value: "Infortunato"},
];

export const playlistOptions = [
	{value: "Clip allenamento", label: "Clip allenamento"},
	{value: "Clip gara", label: "Clip gara"},
	{value: "Video tecnici", label: "Video tecnici"},
];

export const testTypes = [
	{
		label: "Spinte",
		value: "Spinte",
		params: [
			{value: "CMJ", label: "CM Jump", um: "cm", order: 1},
			{value: "CMJL", label: "CM Jump libero", um: "cm", order: 2},
			{value: "CMJ dx", label: "CM Jump mono dx", um: "cm", order: 3},
			{value: "SJ sx", label: "CM Jump mono sx", um: "cm", order: 4},
			{value: "CMJL dx", label: "CM Jump mono libero dx", um: "cm", order: 5},
			{value: "SJL sx", label: "CM Jump mono libero sx", um: "cm", order: 6},
			{value: "SJ", label: "Squat Jump", um: "cm", order: 7},
			{value: "SJ mono dx", label: "SJ mono libero dx", um: "cm", order: 8},
			{value: "SJ mono sx", label: "SJ mono libero sx", um: "cm", order: 9},
			{
				value: "Stiffness h",
				label: "Stiffness",
				um: "cm",
				order: 10,
			},
			{value: "Stiffness TC", label: "Stiffness TC", um: "s", order: 11},
			{value: "Stiffness TV", label: "Stiffness TV", um: "s", order: 12},
			{
				value: "Stiffness bl h",
				label: "Stiffness braccia libere",
				um: "cm",
				order: 13,
			},
			{
				value: "Stiffness bl TC",
				label: "Stiffness braccia libere TC",
				um: "s",
				order: 14,
			},
			{
				value: "Stiffness bl TV",
				label: "Stiffness braccia libere TV",
				um: "s",
				order: 15,
			},
			{value: 'CMJ 15" h', label: 'CMJ 15"', um: "cm", order: 16},
			{value: 'CMJ 15" TC', label: 'CMJ 15" TC', um: "s", order: 17},
			{value: 'CMJ 15" TV', label: 'CMJ 15" TV', um: "s", order: 18},
		],
	},
	{
		label: "Corse",
		value: "Corse",
		params: [
			{value: "5 metri", label: "5 metri", um: "s", order: 1},
			{value: "10 metri", label: "10 metri", um: "s", order: 2},
			{value: "15 metri", label: "15 metri", um: "s", order: 3},
		],
	},
];

export const movementPlayersTestTypes = [
	{
		label: "Test di resistenza",
		value: "Test di resistenza",
		params: [
			{value: "Yo-Yo", label: "Yo-Yo Intermittent Recovery", um: "m"},
			{value: "RSA", label: "RSA Capanna-Sassi", um: "s"},
		],
	},
	{
		label: "Test di agilità",
		value: "Test di agilità",
		params: [{value: "Illinois", label: "Agility Illinois", um: "s"}],
	},
	{
		label: "Test di forza esplosiva",
		value: "Test di forza esplosiva",
		params: [
			{value: "CMJ", label: "CMJ vin", um: "cm"},
			{value: "CMJ_L", label: "CMJ lib", um: "cm"},
			{value: "CMJ_L_dx", label: "CMJ lib dx", um: "cm"},
			{value: "CMJ_L_sx", label: "CMJ lib sx", um: "cm"},
			{value: "SLH_dx", label: "SL Hop dx", um: "cm"},
			{value: "SLH_sx", label: "SL Hop sx", um: "cm"},
			{value: "SLJ_dx", label: "SL DropJ dx", um: "cm"},
			{value: "SLJ_sx", label: "SL DropJ sx", um: "cm"},
		],
	},
];

export const defaultReportOptions = [
	{label: "Molto", value: "0"},
	{label: "Abbastanza", value: "1"},
	{label: "Poco", value: "2"},
];
export const originReportOptions = [
	{label: "Italia", value: "0"},
	{label: "Estero", value: "1"},
];

export const childTypeOptions = [
	{label: "Introverso", value: "0"},
	{label: "Estroverso", value: "1"},
];

export const communicationTypeOptions = [
	{label: "Adeguata", value: "0"},
	{label: "Non adeguata", value: "1"},
];

export const bodyTypeOptions = [
	{label: "Buona", value: "0"},
	{label: "Sufficiente", value: "1"},
	{
		label: "Insufficiente",
		value: "2",
	},
];
export const aptitudeForRole = [
	{label: "Si", value: "0"},
	{label: "No", value: "1"},
];

export const startingPlayer = [
	{label: "Si", value: "0"},
	{label: "No", value: "1"},
];

export const valuationOptions = [
	{label: "Idoneo", value: "0"},
	{label: "Non idoneo", value: "1"},
	{label: "Da seguire", value: "2"},
];

export const valuationAnalysisOption = [
	{label: "Da vedere live", value: "to_view_live"},
	{label: "Da vedere video", value: "to_view_video"},
	{label: "Da provare", value: "to_test"},
	{label: "Visto live", value: "viewed_live"},
	{label: "Visto video", value: "viewed_video"},
];

export const externalValuationOptions = [
	{label: "Idoneo", value: "0"},
	{label: "Non idoneo", value: "1"},
	{label: "Da rivedere", value: "2"},
	{label: "Non interessante", value: "3"},
];

export const dateFormat = "DD/MM/YYYY";

export const DEFAULT_CATEGORY_ID = "e2ba9471-9add-4232-9881-a1bd1f1d28df";

export const REQUIRED_FIELD = "Campo obbligatorio";

export const SUCCESSFUL_OPERATION = "Operazione avvenuta con successo!";
export const ERROR_OPERATION =
	"Spiacenti, si è verificato un problema. Riprova!";

export const valuationsTypes = [
	{value: "match", label: "Valutazione tecnica"},
	{value: "scout", label: "Valutazione scout"},
	{value: "quick", label: "Valutazione dirigente"},
];
// ESTERNI BASE GARA
export const baseExternMatchParameters = (t) => [
	{
		label: t("body_type"),
		area: "struttura",
		fieldKey: "bodyTypeText",
		fieldKeyRating: "bodyTypeRating",
	},
	{
		label: t("personality_1"),
		area: "personalità",
		fieldKey: "personalityText",
		fieldKeyRating: "personalityRating",
	},
	{
		label: t("space_defence"),
		area: "tattica",
		fieldKey: "positionsText",
		fieldKeyRating: "positionsRating",
	},
	{
		label: t("attitude_to_role"),
		area: "tecnica",
		fieldKey: "attitudeToRoleText",
		fieldKeyRating: "attitudeToRoleRating",
	},
	{
		label: t("motricity"),
		area: "condizionali",
		fieldKey: "motricityText",
		fieldKeyRating: "motricityRating",
	},
	{
		label: t("involvement_in_game"),
		area: "tecnica",
		fieldKey: "involvementInGameText",
		fieldKeyRating: "involvementInGameRating",
	},
	{
		label: t("quick_thinking"),
		area: "personalità",
		fieldKey: "quickThinkingText",
		fieldKeyRating: "quickThinkingRating",
	},
	{
		label: t("reactive_capabilities_1"),
		area: "condizionali",
		fieldKey: "reactiveCapabilitiesText",
		fieldKeyRating: "reactiveCapabilitiesRating",
	},
	{
		label: t("attitude_as_outfield_player_1"),
		area: "tecnica",
		fieldKey: "attitudeAsOutfieldPlayerText",
		fieldKeyRating: "attitudeAsOutfieldPlayerRating",
	},
	{
		label: t("ability_to_choices_1"),
		area: "tattica",
		fieldKey: "abilityToChoicesText",
		fieldKeyRating: "abilityToChoicesRating",
	},
];
// ESTERNI AGONISTICA GARA
export const proExternMatchParameters = (t) => [
	{
		label: t("body_type"),
		area: "struttura",
		fieldKey: "bodyTypeText",
		fieldKeyRating: "bodyTypeRating",
	},
	{
		label: t("personality_2"),
		area: "personalità",
		fieldKey: "personalityText",
		fieldKeyRating: "personalityRating",
	},
	{
		label: t("positions_1"),
		area: "tattica",
		fieldKey: "positionsText",
		fieldKeyRating: "positionsRating",
	},
	{
		label: t("postures_1"),
		area: "tecnica",
		fieldKey: "posturesText",
		fieldKeyRating: "posturesRating",
	},
	{
		label: t("goal_defence_1"),
		area: "tecnica",
		fieldKey: "goalDefenceText",
		fieldKeyRating: "goalDefenceRating",
	},
	{
		label: t("space_defence_2"),
		area: "tattica",
		fieldKey: "spaceDefenceText",
		fieldKeyRating: "spaceDefenceRating",
	},
	{
		label: t("podal_technique_1"),
		area: "tecnica",
		fieldKey: "podalTechniqueText",
		fieldKeyRating: "podalTechniqueRating",
	},
	{
		label: t("restarts_1"),
		area: "tattica",
		fieldKey: "restartsText",
		fieldKeyRating: "restartsRating",
	},
	{
		label: t("ability_to_choices_2"),
		area: "condizionali",
		fieldKey: "strengthText",
		fieldKeyRating: "strengthRating",
	},
	{
		label: t("reactive_capabilities_1"),
		area: "condizionali",
		fieldKey: "reactiveCapabilitiesText",
		fieldKeyRating: "reactiveCapabilitiesRating",
	},
];

// ESTERNI BASE ALLENAMENTO
export const baseExternTrainingParameters = (t) => [
	{
		label: t("reaction_to_error_1"),
		area: "tattica",
		fieldKey: "learningAbilityText",
		fieldKeyRating: "learningAbilityRating",
	},
	{
		label: t("personality_3"),
		area: "personalità",
		fieldKey: "personalityText",
		fieldKeyRating: "personalityRating",
	},
	{
		label: t("space_defence"),
		area: "tattica",
		fieldKey: "positionsText",
		fieldKeyRating: "positionsRating",
	},
	{
		label: t("attitude_to_role"),
		area: "tecnica",
		fieldKey: "attitudeToRoleText",
		fieldKeyRating: "attitudeToRoleRating",
	},
	{
		label: t("motricity"),
		area: "condizionali",
		fieldKey: "motricityText",
		fieldKeyRating: "motricityRating",
	},
	{
		label: t("involvement_in_game"),
		area: "tecnica",
		fieldKey: "involvementInGameText",
		fieldKeyRating: "involvementInGameRating",
	},
	{
		label: t("competitiveness"),
		area: "personalità",
		fieldKey: "competitivenessText",
		fieldKeyRating: "competitivenessRating",
	},
	{
		label: t("reaction_to_error_2"),
		area: "personalità",
		fieldKey: "reactionToErrorText",
		fieldKeyRating: "reactionToErrorRating",
	},
	{
		label: t("quick_thinking"),
		area: "personalità",
		fieldKey: "quickThinkingText",
		fieldKeyRating: "quickThinkingRating",
	},
	{
		label: t("reactive_capabilities_3"),
		area: "condizionali",
		fieldKey: "reactiveCapabilitiesText",
		fieldKeyRating: "reactiveCapabilitiesRating",
	},
	{
		fieldKey: "inclusionIntoTeamText",
		label: t("inclusion_into_team_1"),
		fieldKeyRating: "inclusionIntoTeamRating",
		area: "personalità",
	},
	{
		label: t("attitude_as_outfield_player_1"),
		area: "tecnica",
		fieldKey: "attitudeAsOutfieldPlayerText",
		fieldKeyRating: "attitudeAsOutfieldPlayerRating",
	},
];
// ESTERNI AGONISTICA ALLENAMENTO
export const proExternTrainingParameters = (t) => [
	{
		label: t("learning_ability_1"),
		area: "tattica",
		fieldKey: "learningAbilityText",
		fieldKeyRating: "learningAbilityRating",
	},
	{
		label: t("personality_4"),
		area: "personalità",
		fieldKey: "personalityText",
		fieldKeyRating: "personalityRating",
	},
	{
		label: t("positions_1"),
		area: "tattica",
		fieldKey: "positionsText",
		fieldKeyRating: "positionsRating",
	},
	{
		label: t("postures_1"),
		area: "tecnica",
		fieldKey: "posturesText",
		fieldKeyRating: "posturesRating",
	},
	{
		label: t("goal_defence_1"),
		area: "tecnica",
		fieldKey: "goalDefenceText",
		fieldKeyRating: "goalDefenceRating",
	},
	{
		label: t("space_defence_2"),
		area: "tattica",
		fieldKey: "spaceDefenceText",
		fieldKeyRating: "spaceDefenceRating",
	},
	{
		label: t("podal_technique_1"),
		area: "tecnica",
		fieldKey: "podalTechniqueText",
		fieldKeyRating: "podalTechniqueRating",
	},
	{
		label: t("restarts_1"),
		area: "tattica",
		fieldKey: "restartsText",
		fieldKeyRating: "restartsRating",
	},
	{
		label: t("ability_to_choices_2"),
		area: "condizionali",
		fieldKey: "strengthText",
		fieldKeyRating: "strengthRating",
	},
	{
		label: t("reactive_capabilities_1"),
		area: "condizionali",
		fieldKey: "reactiveCapabilitiesText",
		fieldKeyRating: "reactiveCapabilitiesRating",
	},
	{
		fieldKey: "inclusionIntoTeamText",
		label: t("inclusion_into_team_1"),
		fieldKeyRating: "inclusionIntoTeamRating",
		area: "personalità",
	},
	{
		fieldKey: "testResultText",
		label: t("test_result_1"),
		fieldKeyRating: "testResultRating",
		area: "capacità condizionali",
	},
];

// INTERNI
export const initialValuationParameters = (t) => [
	{
		fieldKey: "learningAbilityText",
		label: t("learning_ability_2"),
		fieldKeyRating: "learningAbilityRating",
		area: "tattica",
	},
	{
		fieldKey: "personalityText",
		label: t("personality_4"),
		fieldKeyRating: "personalityRating",
		area: "personalità",
	},
	{
		fieldKey: "positionsText",
		label: t("positions_1"),
		fieldKeyRating: "positionsRating",
		area: "tattica",
		roles: ["portiere", "difensore"],
	},
	{
		fieldKey: "positionsText",
		label: t("positions_4"),
		fieldKeyRating: "positionsRating",
		area: "tattica",
		roles: ["centrocampista", "esterno"],
	},
	{
		fieldKey: "positionsText",
		label: t("positions_5"),
		fieldKeyRating: "positionsRating",
		area: "tattica",
		roles: ["attaccante"],
	},
	{
		fieldKey: "posturesText",
		label: t("postures_1"),
		fieldKeyRating: "posturesRating",
		area: "tattica",
		roles: ["portiere"],
	},
	{
		fieldKey: "posturesText",
		label: t("postures_4"),
		fieldKeyRating: "posturesRating",
		area: "tattica",
		roles: ["difensore"],
	},
	{
		fieldKey: "posturesText",
		label: t("postures_5"),
		fieldKeyRating: "posturesRating",
		area: "tattica",
		roles: ["centrocampista", "attaccante"],
	},
	{
		fieldKey: "posturesText",
		label: t("postures_6"),
		fieldKeyRating: "posturesRating",
		area: "tattica",
		roles: ["esterno"],
	},
	{
		fieldKey: "goalDefenceText",
		label: t("goal_defence_1"),
		fieldKeyRating: "goalDefenceRating",
		area: "tecnica",
		roles: ["portiere"],
	},
	{
		label: t("space_defence_2"),
		area: "tattica",
		fieldKey: "spaceDefenceText",
		fieldKeyRating: "spaceDefenceRating",
		roles: ["portiere"],
	},
	{
		label: t("duels_1"),
		area: "tattica",
		fieldKey: "duelsText",
		fieldKeyRating: "duelsRating",
		roles: ["difensore"],
	},
	{
		label: t("duels_2"),
		area: "tattica",
		fieldKey: "duelsText",
		fieldKeyRating: "duelsRating",
		roles: ["centrocampista", "esterno"],
	},
	{
		label: t("duels_3"),
		area: "tattica",
		fieldKey: "duelsText",
		fieldKeyRating: "duelsRating",
		roles: ["attaccante"],
	},
	{
		label: t("role_abilities_1"),
		area: "tattica",
		fieldKey: "roleAbilitiesText",
		fieldKeyRating: "roleAbilitiesRating",
		roles: ["difensore"],
	},
	{
		label: t("role_abilities_2"),
		area: "tattica",
		fieldKey: "roleAbilitiesText",
		fieldKeyRating: "roleAbilitiesRating",
		roles: ["centrocampista"],
	},
	{
		label: t("role_abilities_3"),
		area: "tattica",
		fieldKey: "roleAbilitiesText",
		fieldKeyRating: "roleAbilitiesRating",
		roles: ["esterno"],
	},
	{
		label: t("role_abilities_4"),
		area: "tattica",
		fieldKey: "roleAbilitiesText",
		fieldKeyRating: "roleAbilitiesRating",
		roles: ["attaccante"],
	},
	{
		fieldKey: "podalTechniqueText",
		label: t("podal_technique_3"),
		fieldKeyRating: "podalTechniqueRating",
		area: "tecnica",
		roles: ["portiere"],
	},
	{
		fieldKey: "podalTechniqueText",
		label: t("podal_technique_4"),
		fieldKeyRating: "podalTechniqueRating",
		area: "tecnica",
		roles: ["difensore"],
	},
	{
		fieldKey: "podalTechniqueText",
		label: t("podal_technique_5"),
		fieldKeyRating: "podalTechniqueRating",
		area: "tecnica",
		roles: ["centrocampista"],
	},
	{
		fieldKey: "podalTechniqueText",
		label: t("podal_technique_6"),
		fieldKeyRating: "podalTechniqueRating",
		area: "tecnica",
		roles: ["esterno"],
	},
	{
		fieldKey: "podalTechniqueText",
		label: t("podal_technique_7"),
		fieldKeyRating: "podalTechniqueRating",
		area: "tecnica",
		roles: ["attaccante"],
	},
	{
		fieldKey: "restartsText",
		label: t("restarts_1"),
		fieldKeyRating: "restartsRating",
		area: "tecnica",
		roles: ["portiere"],
	},
	{
		fieldKey: "restartsText",
		label: t("restarts_4"),
		fieldKeyRating: "restartsRating",
		area: "tecnica",
		roles: ["difensore"],
	},
	{
		fieldKey: "restartsText",
		label: t("restarts_5"),
		fieldKeyRating: "restartsRating",
		area: "tecnica",
		roles: ["centrocampista"],
	},
	{
		fieldKey: "restartsText",
		label: t("restarts_6"),
		fieldKeyRating: "restartsRating",
		area: "tecnica",
		roles: ["esterno"],
	},
	{
		fieldKey: "restartsText",
		label: t("restarts_7"),
		fieldKeyRating: "restartsRating",
		area: "tecnica",
		roles: ["attaccante"],
	},
	{
		fieldKey: "strengthText",
		label: t("ability_to_choices_2"),
		fieldKeyRating: "strengthRating",
		area: "capacità condizionali",
		roles: ["portiere", "difensore"],
	},
	{
		fieldKey: "strengthText",
		label: t("availability_to_run_1"),
		fieldKeyRating: "strengthRating",
		area: "capacità condizionali",
		roles: ["centrocampista", "esterno"],
	},
	{
		fieldKey: "strengthText",
		label: t("availability_to_run_2"),
		fieldKeyRating: "strengthRating",
		area: "capacità condizionali",
		roles: ["attaccante"],
	},
	{
		fieldKey: "reactiveCapabilitiesText",
		label: t("reactive_capabilities_5"),
		fieldKeyRating: "reactiveCapabilitiesRating",
		area: "tattica",
	},
	{
		fieldKey: "inclusionIntoTeamText",
		label: t("inclusion_into_team_1"),
		fieldKeyRating: "inclusionIntoTeamRating",
		area: "personalità",
	},
	{
		fieldKey: "testResultText",
		label: t("test_result_1"),
		fieldKeyRating: "testResultRating",
		area: "capacità condizionali",
	},
];

// INTERNI ATTIVITÀ DI BASE (giocatori di movimento)
export const initialBaseValuationParameters = (t) => [
	{
		fieldKey: "learningAbilityText",
		label: t("reaction_to_error_1"),
		fieldKeyRating: "learningAbilityRating",
		area: "tattica",
	},
	{
		fieldKey: "reactiveCapabilitiesText",
		label: t("quick_thinking"),
		fieldKeyRating: "reactiveCapabilitiesRating",
		area: "tattica",
	},
	{
		fieldKey: "personalityText",
		label: t("personality_6"),
		fieldKeyRating: "personalityRating",
		area: "personalità",
	},
	{
		fieldKey: "competitivenessText",
		label: t("competitiveness_2"),
		fieldKeyRating: "competitivenessRating",
		area: "personalità",
	},
	{
		fieldKey: "inclusionIntoTeamText",
		label: t("inclusion_into_team_1"),
		fieldKeyRating: "inclusionIntoTeamRating",
		area: "personalità",
	},
	{
		fieldKey: "involvementInGameText",
		label: t("involvement_in_game"),
		fieldKeyRating: "involvementInGameRating",
		area: "tecnica",
	},
	{
		fieldKey: "attitudeAsOutfieldPlayerText",
		label: t("attitude_as_outfield_player_3"),
		fieldKeyRating: "attitudeAsOutfieldPlayerRating",
		area: "tecnica",
	},
	{
		fieldKey: "duelsText",
		label: t("duels_5"),
		fieldKeyRating: "duelsRating",
		area: "tattica",
	},
	{
		fieldKey: "positionsText",
		label: t("role_abilities_5"),
		fieldKeyRating: "positionsRating",
		area: "tattica",
	},
	{
		fieldKey: "attitudeToRoleText",
		label: t("role_abilities_6"),
		fieldKeyRating: "attitudeToRoleRating",
		area: "tattica",
	},
	{
		fieldKey: "motricityText",
		label: t("motricity_3"),
		fieldKeyRating: "motricityRating",
		area: "condizionali",
	},
	{
		fieldKey: "posturesText",
		label: t("reactive_capabilities_6"),
		fieldKeyRating: "posturesRating",
		area: "condizionali",
	},
];

// INTERNI ATTIVITÀ DI BASE (portieri) — set storico
export const initialBaseGoalkeeperValuationParameters = (t) => [
	{
		fieldKey: "learningAbilityText",
		label: t("reaction_to_error_1"),
		fieldKeyRating: "learningAbilityRating",
		area: "tattica",
	},
	{
		fieldKey: "personalityText",
		label: t("personality_7"),
		fieldKeyRating: "personalityRating",
		area: "personalità",
	},
	{
		fieldKey: "positionsText",
		label: t("role_abilities_7"),
		fieldKeyRating: "positionsRating",
		area: "tattica",
	},
	{
		fieldKey: "attitudeToRoleText",
		label: t("role_abilities_8"),
		fieldKeyRating: "attitudeToRoleRating",
		area: "tecnica",
	},
	{
		fieldKey: "motricityText",
		label: t("motricity_4"),
		fieldKeyRating: "motricityRating",
		area: "condizionali",
	},
	{
		fieldKey: "involvementInGameText",
		label: t("involvement_in_game"),
		fieldKeyRating: "involvementInGameRating",
		area: "tecnica",
	},
	{
		fieldKey: "competitivenessText",
		label: t("competitiveness"),
		fieldKeyRating: "competitivenessRating",
		area: "personalità",
	},
	{
		fieldKey: "reactionToErrorText",
		label: t("reaction_to_error_2"),
		fieldKeyRating: "reactionToErrorRating",
		area: "personalità",
	},
	{
		fieldKey: "reactiveCapabilitiesText",
		label: t("quick_thinking"),
		fieldKeyRating: "reactiveCapabilitiesRating",
		area: "tattica",
	},
	{
		fieldKey: "posturesText",
		label: t("reactive_capabilities_7"),
		fieldKeyRating: "posturesRating",
		area: "condizionali",
	},
	{
		fieldKey: "inclusionIntoTeamText",
		label: t("inclusion_into_team_1"),
		fieldKeyRating: "inclusionIntoTeamRating",
		area: "personalità",
	},
	{
		fieldKey: "attitudeAsOutfieldPlayerText",
		label: t("attitude_as_outfield_player_4"),
		fieldKeyRating: "attitudeAsOutfieldPlayerRating",
		area: "tecnica",
	},
];

// Seleziona il set base corretto in base al ruolo:
// portiere -> set storico; tutti gli altri ruoli di movimento -> set movimento
export const getInitialBaseValuationParameters = (t, player) => {
	const isGoalkeeper =
		player?.goalkeeper || player?.primaryRole === "Portiere";
	return isGoalkeeper
		? initialBaseGoalkeeperValuationParameters(t)
		: initialBaseValuationParameters(t);
};

// ESTERNI MOVIMENTO
export const externOutfieldMatchParameters = (t) => [
	{
		label: t("tecnic"),
		area: "tecnica",
		fieldKey: "technique",
	},
	{
		label: t("Tattica"),
		area: "tattica",
		fieldKey: "tactics",
	},
	{
		label: t("athletics"),
		area: "atletica",
		fieldKey: "athletics",
	},
	{
		label: t("psychological_characteristics"),
		area: "psicologica",
		fieldKey: "psychologicalProfile",
	},
	{
		label: t("height_description"),
		area: "atletica",
		fieldKey: "heightDescription",
	},
	{
		label: t("weight_description"),
		area: "atletica",
		fieldKey: "weightDescription",
	},
	{
		label: t("body_type_3"),
		area: "atletica",
		fieldKey: "bodyStructure",
	},
	{
		label: t("morphology"),
		area: "atletica",
		fieldKey: "morphology",
	},
];

export const entitySaveOptions = [
	{value: "new", label: "Inserisci nuovo elemento"},
	{value: "select", label: "Seleziona esistente"},
];

export const activityTypesOptions = [
	{value: "base", label: "Attività di base"},
	{value: "competitive", label: "Attività agonistica"},
];

export const playerSemaphoreOptions = [
	{label: "1° fascia", value: 1},
	{label: "2° fascia", value: 2},
	{label: "3° fascia", value: 3},
];
